import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import _ from "lodash";

import { Button, Card, Modal } from "antd";
import UserNavs from "./UserNavs";

import { showAppModal, getPrefs } from "redux/actions/app";
import {
  getUserV2,
  createUserView,
  CREATE_USER_VIEW,
  setUserInfo,
} from "redux/actions/user";
import { authUrlSilently, isWechatBrowser } from "utils/wechat";

const isWechat = isWechatBrowser();

const Page = ({
  token,
  user: viewedUser,
  currentUser,
  prefs,
  event,
  showAppModal,
  createUserView,
  getPrefs,
  setUserInfo,
}: {
  token: any;
  user: any;
  currentUser: any;
  prefs: any;
  event: any;
  showAppModal: any;
  createUserView: any;
  getPrefs: any;
  setUserInfo: any;
}) => {
  const [user, setUser] = useState<any>(viewedUser);
  const [skillTypeTag, setSkillTypeTag] = useState<any>();
  const [workTypeTags, setWorkTypeTags] = useState<any>();

  const renderValue = (value: any, render: any = null) => {
    const v = _.isString(value) ? _.trim(value) : value;

    if (_.isEmpty(v)) {
      return <span className="text-secondary">暂无</span>;
    } else {
      return render ? render(v) : v;
    }
  };

  const renderContact = () => {
    if (_.has(user, "contact_info")) {
      return renderValue(user.contact_info, (value: any) => (
        <div>
          {value}
          <span className="ml-10">（{prefs.user_contact_hint}）</span>
        </div>
      ));
    } else {
      return (
        <Button type="primary" size="small" onClick={handleContactModal} ghost>
          查看联系方式
        </Button>
      );
    }
  };

  const handleContactModal = () => {
    if (!token) {
      showAppModal("PhoneSigninModal");
      return;
    }

    const myEle = currentUser.ele;
    if (myEle && myEle >= 5) {
      // 当我的电量多于5时，或未读取到我的电量时。
      // 后续再把5改为全局常量。
      Modal.confirm({
        title: "确认要查看联系方式吗？",
        content: (
          <p>
            查看联系方式将消耗 <span className="text-primary">5</span> 电量
          </p>
        ),
        onOk() {
          createUserView(token, user.id);
        },
      });
    } else {
      // 当我的电量小于5时。
      Modal.confirm({
        title: "电量余额不足",
        okText: "去充电",
        closable: true,
        content: (
          <div>
            <p>哎呀，您的电量不足啦！可付费充电，支持社区发展哦：）</p>
            <p>
              <a
                href="https://eleduck.com/posts/6GzfGe"
                className="text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                电量的作用及如何获取电量？
              </a>
            </p>
          </div>
        ),
        onOk(): any {
          if (isWechat) {
            if (!currentUser.temp_code) {
              let itsURL = window.location.href;
              let tempCode = new URL(itsURL).searchParams.get("code");
              if (!tempCode) {
                let param =
                  itsURL.indexOf("?") > 0 ? "&ispaying=true" : "?ispaying=true";
                return (window.location.href = authUrlSilently(itsURL + param));
              } else {
                currentUser.temp_code = tempCode;
                setUserInfo({ ...currentUser, temp_code: tempCode });
              }
            }
          }

          showAppModal("TopUpModal");
        },
        okButtonProps: { disabled: true }, // TODO: ICP备案恢复后移除
      });
    }
  };
  useEffect(() => {
    getPrefs();

    if (isWechat) {
      let itsURL = new URL(window.location.href);
      if (itsURL.searchParams.get("ispaying") === "true") {
        setUserInfo({
          ...currentUser,
          temp_code: itsURL.searchParams.get("code"),
        });
        showAppModal("TopUpModal");
      }
    }
  }, []);

  // const renderOpusLinks = (links: any) =>
  //   links.map((link: any, i: any) => (
  //     <a
  //       href={link}
  //       target="_blank"
  //       rel="noopener noreferrer"
  //       key={`${link}/${i}`}
  //     >
  //       {link}
  //     </a>
  //   ));

  const handleUserFetch = () => {
    getUserV2(token, user.id).then((user: any) => {
      setUser(user);
    });
  };
  const handleEvent = () => {
    const { name } = event;
    if (name === CREATE_USER_VIEW) {
      handleUserFetch();
    }
  };
  useEffect(() => {
    setUser(viewedUser);
    setSkillTypeTag(
      _.find(user.tags, (x) => x.tag_group.code === "skill_type")
    );
    setWorkTypeTags(
      _.filter(user.tags, (x) => x.tag_group.code === "work_type")
    );
  }, [viewedUser]);

  useEffect(() => handleEvent(), [event]);

  return (
    <Card>
      <UserNavs user={user} activeKey="info" />

      <table>
        <tbody>
          <tr>
            <th>
              <div>详细介绍</div>
            </th>
            <td>{renderValue(user.bio)}</td>
          </tr>
          <tr>
            <th>
              <div>专业领域</div>
            </th>
            <td>{renderValue(skillTypeTag, (tag: any) => tag.name)}</td>
          </tr>
          <tr>
            <th>
              <div>职业身份</div>
            </th>
            <td>
              {renderValue(workTypeTags, (tags: any) =>
                _.map(tags, "name").join("、")
              )}
            </td>
          </tr>
          <tr>
            <th>
              <div>目前职位</div>
            </th>
            <td>{renderValue(user.job_title)}</td>
          </tr>
          <tr>
            <th>
              <div>所在城市</div>
            </th>
            <td>{renderValue(user.location)}</td>
          </tr>
          <tr>
            <th>
              <div>个人性别</div>
            </th>
            <td>
              {renderValue(user.gender, (v: any) =>
                v === "male" ? "男" : "女"
              )}
            </td>
          </tr>
          <tr>
            <th>
              <div>联系方式</div>
            </th>
            <td>{renderContact()}</td>
          </tr>

          {/* <tr>
              <th><div>作品链接</div></th>
              <td>{renderValue(state.user.opus_links, renderOpusLinks)}</td>
            </tr> */}
        </tbody>
      </table>
      <style>
        {`
        table {
          margin: 10px;
        }

        table th div {
          width: 60px;
        }

        table th, table td {
          padding-top: 10px;
          padding-bottom: 10px;
        }

        table td {
          padding-left: 20px;
        }
      `}
      </style>
    </Card>
  );
};
const mapStateToProps = (state: any) => ({
  token: state.user.token,
  currentUser: state.user.user,
  event: state.app.event,
  prefs: state.app.prefs,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showAppModal,
      createUserView,
      getPrefs,
      setUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Page);
